import { DefaultTheme } from 'styled-components';
import { buttonKinds } from '../components/Button/Button';

// Keep this the same as the one from themeSelector in app storybook
export const getPrimaryTextColor = (theme: DefaultTheme, kind: string) => {
	switch (kind) {
		case 'blackslate':
			return theme.colors.white;
		case 'white':
			return theme.colors.darkGreyR;
		default:
			return theme.colors.white;
	}
};

export const getSecondaryTextColor = (theme: DefaultTheme, kind: string) => {
	switch (kind) {
		case 'blackslate':
			return theme.colors.greyR;
		case 'white':
			return theme.colors.darkR;
		default:
			return theme.colors.greyR;
	}
};

// <TextInput />
export const getTextInputBackgroundColor = (theme: DefaultTheme, kind: string) => {
	switch (kind) {
		case 'blackslate':
			return theme.colors.darkGreyR;
		case 'white':
			return theme.colors.white;
		default:
			return theme.colors.darkGreyR;
	}
};

export const getTextInputBorderColor = (theme: DefaultTheme, kind: string) => {
	switch (kind) {
		case 'blackslate':
			return 'transparent';
		case 'white':
			return theme.colors.lightGreyR;
		default:
			return 'transparent';
	}
};

// <Button />
export const getButtonTextColor = (theme: DefaultTheme, kind: buttonKinds) => {
	switch (kind) {
		case 'fantasy':
			return theme.colors.white;
		case 'blackslate':
			return theme.colors.darkR;
		case 'white':
			return theme.colors.white;
		case 'hollow-white':
			return theme.colors.white;
		case 'hollow-black':
			return theme.colors.darkR;
		case 'transparent-white':
			return theme.colors.white;
		case 'danger':
			return theme.colors.white;
		case 'playup':
		case 'primary':
			return theme.colors.darkR;
		default:
			return theme.colors.darkR;
	}
};

export const getButtonBackgroundColor = (theme: DefaultTheme, kind: buttonKinds) => {
	switch (kind) {
		case 'fantasy':
			return '#ff0056';
		case 'blackslate':
			return theme.colors.white;
		case 'white':
			return theme.colors.darkR;
		case 'hollow-white':
			return theme.colors.transparent;
		case 'hollow-black':
			return theme.colors.transparent;
		case 'transparent-white':
			return theme.colors.transparent;
		case 'danger':
			return theme.colors.danger;
		case 'primary':
		case 'playup':
			return theme.colors.primary;
		default:
			return theme.colors.white;
	}
};

export const getButtonBorderColor = (theme: DefaultTheme, kind: buttonKinds) => {
	switch (kind) {
		case 'blackslate':
			return theme.colors.transparent;
		case 'white':
			return theme.colors.transparent;
		case 'hollow-white':
			return theme.colors.greyR;
		case 'hollow-black':
			return theme.colors.greyR;
		case 'transparent-white':
			return theme.colors.transparent;
		case 'danger':
			return theme.colors.transparent;
		case 'playup':
		case 'primary':
			return theme.colors.transparent;
		default:
			return theme.colors.transparent;
	}
};
